// extracted by mini-css-extract-plugin
export var button = "_6j-4";
export var hasDarkBackground = "_6j-7";
export var hasLightBackground = "_6j-6";
export var iconWrapper = "_6j-0";
export var large = "_6j-2";
export var medium = "_6j-1";
export var small = "_6j-5";
export var xsmall = "_6j-3";